import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import { getFileDownloadUrl } from "../../../../api/firebase/firestoreService";
import CustomTable from "../../../../components/custom-table/custom-table";
import NycbsMedicalPaDetailsModal from "../../../../components/modals/nycbsMedicalPaDetailsModal/nycbsMedicalPaDetailsModal";
import { EligibilityCheckTableData } from "../../../../data-model/tablesData";
import { RootState } from "../../../../redux/store/store";
import { logDataToConsole, logError } from "../../../../utils/customLogger";
import {
  EligibilityTableHeader,
  generateEligibilityTableData,
  updateDownloadStatusOfOrderWithId,
} from "../../utils/eligibilityTableDataGenerator";

const EligibilityTable = () => {
  const { data, loading } = useSelector(
    (state: RootState) => state.nycbsMedicalPa,
  );

  const [eligibilityTableData, setEligibilityTableData] = useState<
    EligibilityCheckTableData[]
  >([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);

  const handleDownload = (fileUrl: string, fileName: string) => {
    try {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName || "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileUrl);
    } catch (error) {
      logError(error as Error, "Error while downloading file");
    }
  };

  const handleDownloadOfReportFromRef = async (rowData) => {
    const id = rowData?.id ?? "";
    setEligibilityTableData(
      updateDownloadStatusOfOrderWithId(eligibilityTableData, id, false),
    );
    const fileRef = data?.find((el) => el.job_id === id)?.report_url ?? "";
    if (fileRef) {
      const fileUrl = await getFileDownloadUrl(fileRef);
      handleDownload(fileUrl, `${id}_eligibility_check.xlsx`);
      setEligibilityTableData(
        updateDownloadStatusOfOrderWithId(eligibilityTableData, id, true),
      );
    }
  };

  useEffect(() => {
    if (data) {
      setEligibilityTableData(generateEligibilityTableData(data));
    }
  }, [data]);

  useEffect(() => {
    if (showModal) {
      openModal("nycbs-medical-pa-details");
    }
  }, [showModal]);
  return (
    <>
      <CustomTable
        tableHeaders={EligibilityTableHeader}
        tableData={eligibilityTableData}
        tableName={"eligibility-table"}
        hideSearchBar={true}
        count={eligibilityTableData.length}
        totalCount={eligibilityTableData.length}
        pagesPerView={5}
        itemsPerPage={10}
        endIndexOfTable={() => {}}
        isFetching={loading}
        onReviewButtonClick={(data) => {
          setSelectedOrderId(data.id);
          setShowModal(true);
        }}
        onClickableTextWithDisabledStatusClick={(data) => {
          handleDownloadOfReportFromRef(data);
          logDataToConsole(data);
        }}
      />
      {showModal && (
        <NycbsMedicalPaDetailsModal
          onClose={() => setShowModal(false)}
          id={selectedOrderId ?? ""}
        />
      )}
    </>
  );
};

export default EligibilityTable;
